module.exports = __webpack_public_path__ + "static/img/4-2.e583018.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selection/pc/components/past-review/4-2.jpg
// module id = wDGF
// module chunks = 25